import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { ApiError, DetailView } from '@pro4-erp/core-web';
import { useTranslation } from 'react-i18next';
import { getAuditInvitationById } from '../api/getAuditInvitationById';
import { DetailProvider } from '../contexts/DetailContext';
import Team from '../components/Team';
import Details from '../components/Details';
import { AuditInvitationDetail } from '@/common';

const DetailPage = () => {
  const { id } = useParams<{ id: string }>() as { id: string };

  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const navigate = useNavigate();

  const query = useQuery<AuditInvitationDetail, ApiError>(
    ['auditor-invitations-id', id],
    () => getAuditInvitationById(id, lang),
    { refetchOnWindowFocus: false }
  );

  if (query.isLoading) {
    return (
      <Box>
        <Box
          sx={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress size={100} />
        </Box>
      </Box>
    );
  }

  if (query.isError) {
    return <p>{query.error.message}</p>;
  }

  return (
    <Box sx={{ mt: 1 }}>
      <DetailProvider data={query.data}>
        <DetailView
          title={
            <DetailView.Title>
              {`WO: ${query.data.uId || 'N/A'} ${query.data.workOrder?.name || 'N/A'}`}
            </DetailView.Title>
          }
          onGoBack={() => navigate('/audit-invitations')}
          tabs={[
            { id: 'details', title: t('Details', { defaultValue: 'Details' }) },
            { id: 'team', title: t('Team', { defaultValue: 'Team' }) },
          ]}
          defaultTab="details"
          childrenSx={{ padding: '2rem' }}
        >
          {({ TabContent }) => (
            <>
              <TabContent tab="details">
                <Details />
              </TabContent>
              <TabContent tab="team">
                <Team />
              </TabContent>
            </>
          )}
        </DetailView>
      </DetailProvider>
    </Box>
  );
};

export default DetailPage;
